import SharedTextFieldInput from '../shared/TextFieldInput';

interface HomeTextFieldInputProps {
  label: string;
  value: string;
  onChange: (event: any) => void;
  section: number;
  [x: string]: any;
}

const HomeTextFieldInput = (props: HomeTextFieldInputProps) => {
  return <SharedTextFieldInput {...props} formStateKey="homePersonalForm" />;
};

export default HomeTextFieldInput;
